(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (function () {
    function hideEmptyAccordionRows() {
      document.querySelectorAll('[data-accordion-content]').forEach(function (content) {
        if (content.innerHTML.trim() === '') {
          var wrapper = content.closest('accordion-custom');
          if (wrapper) wrapper.style.display = 'none';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideEmptyAccordionRows);
    } else {
      hideEmptyAccordionRows();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
